import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AdminService } from '../../../../../services/admin.service';
import { UserService } from '../../../../../services/user.service';
import { SuggestionListsService } from '../../services/suggestion-lists.service';
import { ComponentBackgroundService } from '../../../../../services/component-background.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReviewSuggestionListsService } from '../../services/review-suggestion-lists.service';
import { ActionSlPopupComponent } from './popups/action-sl-popup/action-sl-popup.component';
import { CancelPopupComponent } from './popups/cancel-popup/cancel-popup.component';
import * as moment from 'moment';
import { FullUser } from '../../../../../models/full-user.model';
import { User } from '../../../../../models/user.model';
import { HttpStatus, SuggestionListStatus, TaskStatus, SuggestionListStatusUtils } from './view-suggestion-list.constants';

@Component({
  selector: 'app-view-suggestion-list',
  templateUrl: './view-suggestion-list.component.html',
  styleUrls: ['./view-suggestion-list.component.css'],
  providers: [NgbActiveModal]
})
export class ViewSuggestionListComponent implements OnInit {
  SuggestionListStatus = SuggestionListStatus;
  TaskStatus = TaskStatus;

  listID: string;
  notifyID: string;
  isLoaded = false;
  selectedSLList = null;
  chatVisible = false;
  msgText = '';
  showError = false;
  showSuccess = false;
  slGroup = null;
  groupHead = null;
  selfUserMe = null;
  isIInitiator = false;
  isIHead = false;
  isIMember = false;
  selectedRedirectDivision = null;
  allGroups: any[] = [];
  redirectResponseMsg = '';
  redirectShowMsg = false;
  disableRedirectBtn = false;
  headProblem = false;
  listOfTasksForHeads: any[] = [];
  suggestionListsServicegetFakeTable: any[] = [];
  firstDisable = false;
  dateOfPostpone;
  listUsers = [];
  users = [];
  groups = [];
  initiator: FullUser;
  create = true;
  redirect = false;
  postphone = false;
  user: User;
  isAdmin = false;
  isUser = false;
  isHead;
  iniciatorListId
  flag = false;
  initiatorList;
  groupDeputy;
  allGroupsList = [];
  currentUser;
  numberpostpone;
  numberRedirect;
  photoUrls: SafeUrl[] = [];
  selectedPhotoUrl: SafeUrl = '';
  showPhotoModal: boolean = false;
  currentPhotoIndex: number = 0;

  constructor(private route: ActivatedRoute,
    public suggestionListsService: SuggestionListsService,
    public reviewSuggestionListsService: ReviewSuggestionListsService,
    public componentBackgroundService: ComponentBackgroundService,
    private userService: UserService,
    private adminService: AdminService,
    private router: Router,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.checkRole();
    this.suggestionListsService.firstDisableService = false;
    this.headProblem = false;
    this.reviewSuggestionListsService.clearOpenedSLID();
    this.isIInitiator = false;
    this.isIHead;
    this.msgText = '';
    this.showError = false;
    this.showSuccess = false;
    this.isLoaded = false;
    this.listID = this.route.snapshot.params['id'];
    this.notifyID = this.route.snapshot.params['notifyId'];
    this.reviewSuggestionListsService.setOpenedSLID(this.listID);
    this.redirectResponseMsg = '';
    this.redirectShowMsg = false;
    this.disableRedirectBtn = false;
    this.currentUser = JSON.parse(localStorage.getItem('User'));
    this.getListByiD();
    this.renameGroup();
  }

  renameGroup() {
    this.adminService.getModalSetting().subscribe(
        (res: any) => {
          this.numberpostpone = res.body.amountOfPossiblePostpones;
          this.numberRedirect = res.body.amountPossibleRedirections;
        }
      );
  }

  getListByiD(){
    this.suggestionListsService.getSLByID(this.listID).subscribe(
      (res: any) => {
        if (res.status === HttpStatus.OK) {
          this.processSLResponse(res);
        } else {
          this.msgText = 'Please contact the server support.';
          this.showError = true;
          this.showSuccess = false;
          this.isLoaded = true;
        }
      },
      () => {
        this.msgText = 'Please contact the server support.';
        this.showError = true;
        this.showSuccess = false;
        this.isLoaded = true;
      }
    );
  }

  private processSLResponse(res: any) {
    this.markNotify(this.listID);
    this.selectedSLList = res.body;
    this.iniciatorListId = this.selectedSLList.initiator.id;
    this.dateOfPostpone = moment(this.selectedSLList.daysToPostpone).format('YYYY-MM-DD');
    const newStatus = this.selectedSLList.status.replace(new RegExp('_', 'g'), ' ');
    this.selectedSLList.status = newStatus;

    if (this.selectedSLList.photoIds && this.selectedSLList.photoIds.length) {
      this.loadPhotos(this.selectedSLList.photoIds);
    } else {
      console.info('No idsPhotos found or empty array');
    }
    if (this.selectedSLList.status === SuggestionListStatus.POSTPONE) {
      this.create = false;
      this.redirect = false;
      this.postphone = true;
    }
    if (this.isHead) {
      this.getGroupById(res.body.group.id);
    }
    this.isSLInProgressTasks();
    this.getCurrentSLDivision();
  }

  cancelSuggesion(reason){
    this.suggestionListsService.cancelSuggesionFull(this.listID, reason).subscribe(
      (response: any) => {
        this.getListByiD();
      }
    )
  }

  restoreSuggesion(reason){
    this.suggestionListsService.restoreSuggesionFull(this.listID, reason).subscribe(
      (response: any) => {
        this.getListByiD();
      }
    )
  }

  markNotify(itemId) {
    const sendingParams = {
      id: itemId,
      notificationCategory: "SUGGESTION_ID"
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      (response: any) => { },
      () => {
        this.isLoaded = false;
      }
    );
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }
  }

  change(type) {
    if (type === 'create') {
      this.create = true;
      this.redirect = false;
      this.postphone = false;
    }
    if (type === 'redirect') {
      this.create = false;
      this.redirect = true;
      this.postphone = false;
    }
    if (type === 'postphone') {
      this.create = false;
      this.redirect = false;
      this.postphone = true;
    }
  }

  getGroupById(id) {
    this.adminService.getAllGroupsForList().subscribe(
      (response: any) => {
        if (response.status === HttpStatus.OK) {
          this.listUsers = response.activeUsers;
          this.allGroupsList = response.body;
          let arr = response.body;
          let b = id;
          const relatedId = arr.findIndex(({ id }) => id === b);
          const [related] = arr.splice(relatedId, 1);
          this.groups = arr;
          this.groups.unshift(related);
          this.users.push(this.groups[0].head);
          this.initiator = this.users[0];
          this.getUsersByIdGroup(id, this.groups[0].head.fullName);
        }
      }
    );
  }

  getUsersByIdGroup(id, name) {
    this.userService.getUsersByIdGroup(id).subscribe(
      (response: any) => {
        if (response.status === HttpStatus.OK) {
          let arr = response.body;
          let b = name;
          const relatedId = arr.findIndex(({ fullName }) => fullName === b);
          arr.sort((firstName, secondName) => (firstName.fullName || '').localeCompare(secondName.fullName || ''));
          const [related] = arr.splice(relatedId, 1);
          this.users = arr;
          this.users.unshift(related);
        }
      }
    )
  }

  changeVisibleChat() {
    this.chatVisible = this.chatVisible ? false : true;
  }

  getCurrentSLDivision() {
    const slGroupID = this.selectedSLList.group.id;
    this.adminService.getGroupByID(slGroupID).subscribe(
      (res: any) => {
        if (res.status === HttpStatus.OK) {
          this.slGroup = res.body;
          this.selectedRedirectDivision = this.slGroup;
          this.processGroupLeadership();
          this.getSelfMe();
        } else {
          this.msgText = 'Please contact the server support.';
          this.showError = true;
          this.showSuccess = false;
          this.isLoaded = true;
        }
      },
      () => {
        this.msgText = 'Please contact the server support.';
        this.showError = true;
        this.showSuccess = false;
        this.isLoaded = true;
      }
    );
  }

  private processGroupLeadership() {
    if (this.slGroup.head !== null && this.slGroup.head !== undefined) {
      this.groupHead = this.slGroup.head;
      if (this.slGroup.deputy) {
        this.groupDeputy = this.slGroup.deputy;
      }
    } else {
      if (this.slGroup.deputy !== null && this.slGroup.deputy !== undefined) {
        this.groupHead = this.slGroup.deputy;
        this.groupDeputy = this.slGroup.deputy;
      } else {
        this.headProblem = true;
        this.groupHead = null;
        this.groupDeputy = null;

        this.msgText = '';
        this.showError = true;
        this.showSuccess = false;
        this.isLoaded = true;
      }
    }
  }

  accept() {
    document.location.reload();
  }

  getSelfMe() {
    this.userService.getSelf().subscribe(
      (res: any) => {
        if (res.status === HttpStatus.OK) {
          this.selfUserMe = res.body;
          this.processUserRoleAndTasks();
        } else {
          this.msgText = '';
          this.showError = true;
          this.showSuccess = false;
          this.isLoaded = true;
        }
      },
      (err) => {
        this.msgText = 'Please contact the server support.';
        this.showError = true;
        this.showSuccess = false;
        this.isLoaded = true;
      }
    );
  }

  private processUserRoleAndTasks() {
    if (this.selfUserMe.id === this.selectedSLList.initiator.id) {
      this.isIInitiator = true;
    } else {
      this.isIInitiator = false;
    }
    if (this.groupHead !== null) {
      this.isIHead = this.groupHead.id === this.selfUserMe.id;
      if (!this.isIHead && this.groupDeputy) {
        this.isIHead = this.groupDeputy.id === this.selfUserMe.id;
      }
    }
    if (this.selectedSLList.hasOwnProperty('tasks')) {
      this.processUserTasks();
    } else {
      this.isIMember = false;
    }
    this.reviewSuggestionListsService.setIsCurrentUserHead(this.isIHead);
    this.reviewSuggestionListsService.setIsCurrentUserInitiator(this.isIInitiator);
    this.reviewSuggestionListsService.setIsCurrentUserMember(this.isIMember);
    if (this.isIHead) {
      this.getAllGroups();
    } else {
      this.allGroups = [];
      this.msgText = '';
      this.isLoaded = true;
    }
  }

  private processUserTasks() {
    if (this.selectedSLList.tasks !== null && this.selectedSLList.tasks !== undefined && this.selectedSLList.tasks.length > 0) {
      this.selectedSLList.tasks.forEach(task => {
        if (task.workerId === this.selfUserMe.id) {
          this.isIMember = true;
        }
      });
    } else {
      this.isIMember = false;
    }
  }

  private getAllGroups() {
    this.adminService.getAllGroupsHead().subscribe(
      (res: any) => {
        if (res.status === HttpStatus.OK) {
          this.allGroups = res.body;
          this.msgText = '';
          this.isLoaded = true;
        } else {
          this.msgText = '';
          this.showError = true;
          this.showSuccess = false;
          this.isLoaded = true;
        }
      },
      (err) => {
        this.msgText = 'Please contact the server support.';
        this.showError = true;
        this.showSuccess = false;
        this.isLoaded = true;
      }
    );
  }

  selectGroup(group: any) {
    this.selectedRedirectDivision = group;
  }

  action(action) {
    const modalRef = this.modalService.open(ActionSlPopupComponent);
    modalRef.componentInstance.setAction(action);
    modalRef.componentInstance.setSL(this.selectedSLList);
    modalRef.componentInstance.setDivisionId(this.selectedRedirectDivision.id, this.selectedSLList.id, this.notifyID);
    modalRef.componentInstance.setAllDevision(this.allGroupsList);
    modalRef.result.then(
      (result) => {

      },
      (reason) => {
        if(action == 'createCEO'){
          this.createCeoTask(reason);
        } 
        if(action == 'close'){
          this.cancelSuggesion(reason);
        } 
        if(action == 'restore'){
          this.restoreSuggesion(reason); 
        }
      }
    );
  }

  createCeoTask(reason){
    this.suggestionListsService.sendToPlanfix(reason).subscribe(
      (res: any) => {
        this.getListByiD();
      },
    );
  }

  cancelPostponement() {
    const modalRef = this.modalService.open(CancelPopupComponent);
    modalRef.componentInstance.setSL(this.selectedSLList, this.notifyID);
  }

  isSLInProgressTasks() {
    if (SuggestionListStatusUtils.isInProgressStatus(this.selectedSLList.status)) {
      if (this.selectedSLList.hasOwnProperty('tasks')) {
        if (this.selectedSLList.tasks !== null && this.selectedSLList.tasks !== undefined) {
          if (Array.isArray(this.selectedSLList.tasks)) {
            this.listOfTasksForHeads = this.listOfTasksForHeads.concat(this.selectedSLList.tasks);
          } else {
            this.listOfTasksForHeads.push(this.selectedSLList.tasks);
          }
        }
      }
    }
  }

  showTasksProgress() {
    return SuggestionListStatusUtils.isInProgressStatus(this.selectedSLList.status) && this.listOfTasksForHeads.length > 0;
  }

  disabledByStatus() {
    let isDisabled = false;
    if (this.selectedSLList.status !== SuggestionListStatus.NEW) {
      if (this.selectedSLList.status === SuggestionListStatus.EXECUTING_TASKS || 
          this.selectedSLList.status === SuggestionListStatus.EXECUTING_TASKS_UNDERSCORE) {
        isDisabled = this.isAllTasksCompleted();
      } else {
        isDisabled = this.handleReviewingStatus(isDisabled);
      }
    } else {
      isDisabled = true;
    }
    return isDisabled;
  }

  private handleReviewingStatus(isDisabled: boolean) {
    if (this.selectedSLList.status === SuggestionListStatus.REVIEWING) {
      isDisabled = this.isAllTasksCompleted();
    } else {
      isDisabled = this.handlePostponeExpiredStatus(isDisabled);
    }
    return isDisabled;
  }

  private handlePostponeExpiredStatus(isDisabled: boolean) {
    if (this.selectedSLList.status === SuggestionListStatus.POSTPONE_EXPIRED ||
      this.selectedSLList.status === SuggestionListStatus.POSTPONE_EXPIRED_UNDERSCORE) {
      isDisabled = true;
    } else {
      isDisabled = this.handleSuggestionTasksExpiredStatus(isDisabled);
    }
    return isDisabled;
  }

  private handleSuggestionTasksExpiredStatus(isDisabled: boolean) {
    if (this.selectedSLList.status === SuggestionListStatus.SUGGESTION_TASKS_EXPIRED ||
      this.selectedSLList.status === SuggestionListStatus.SUGGESTION_TASKS_EXPIRED_UNDERSCORE) {
      isDisabled = true;
    } else {
      isDisabled = false;
    }
    return isDisabled;
  }

  isAllTasksCompleted() {
    let isDone = true;
    this.listOfTasksForHeads.forEach(st => {
      if (st.status !== TaskStatus.DONE && st.status !== TaskStatus.COMPLETED) {
        isDone = false;
      }
    });
    return isDone;
  }

  canModifySuggestion(): boolean {
    return !SuggestionListStatusUtils.isFinalStatus(this.selectedSLList && this.selectedSLList.status);
  }

  isActionableHead(): boolean {
    return this.isIHead && this.canModifySuggestion();
  }

  isActiveStatus(): boolean {
    return !SuggestionListStatusUtils.isFinalStatus(this.selectedSLList && this.selectedSLList.status);
  }

  canBePostponed(): boolean {
    return (this.selectedSLList && this.selectedSLList.status !== SuggestionListStatus.POSTPONE) && 
           (this.selectedSLList && this.selectedSLList.amountOfPossiblePostpones < this.numberpostpone);
  }

  canBeRedirected(): boolean {
    return this.selectedSLList && this.selectedSLList.numberRedirects < this.numberRedirect;
  }

  canCreateTasks(): boolean {
    return SuggestionListStatusUtils.isCreatableStatus(this.selectedSLList && this.selectedSLList.status);
  }

  shouldShowTaskProgress(): boolean {
    return SuggestionListStatusUtils.isInProgressStatus(this.selectedSLList && this.selectedSLList.status) && this.listOfTasksForHeads.length > 0;
  }

  canCancelSuggestion(): boolean {
    return this.disabledByStatus();
  }

  shouldShowImplementationMembers(): boolean {
    return this.isActionableHead() && 
           !this.suggestionListsService.firstDisableService && 
           this.canCancelSuggestion() && 
           this.create;
  }

  shouldShowTaskLinks(): boolean {
    return (this.selectedSLList && this.selectedSLList.tasks && this.selectedSLList.tasks.url) && 
           (this.selectedSLList && this.selectedSLList.status !== SuggestionListStatus.EXECUTING_TASKS);
  }

  shouldShowEmptyTaskMessage(): boolean {
    return this.listOfTasksForHeads.length < 1 && 
           (this.selectedSLList && this.selectedSLList.status === SuggestionListStatus.EXECUTING_TASKS_UNDERSCORE);
  }

  showAdminActionButtons(): boolean {
    return (this.selectedSLList && this.selectedSLList.status === SuggestionListStatus.APPROVE_CANCELLED) && 
           this.isAdmin && 
           this.isHead && 
           (this.currentUser && this.currentUser.mainGroup === '62a311f4bff1153571181b36');
  }

  showCancelButton(): boolean {
    return this.reviewSuggestionListsService.getIsCurrentUserHead() && 
           SuggestionListStatusUtils.isCreatableStatus(this.selectedSLList && this.selectedSLList.status);
  }

  showAcceptButton(): boolean {
    return (this.selectedSLList && this.selectedSLList.status === SuggestionListStatus.CANCELLED) && !!this.notifyID;
  }

  showPostponeControls(): boolean {
    return this.postphone && 
           this.reviewSuggestionListsService.getIsCurrentUserHead() && 
           this.canCreateTasks();
  }

  showRedirectDropdown(): boolean {
    return this.reviewSuggestionListsService.getIsCurrentUserHead() && 
           !this.shouldShowTaskProgress() && 
           this.canCreateTasks();
  }

  isRedirectButtonDisabled(): boolean {
    return (this.selectedRedirectDivision && this.selectedRedirectDivision.id !== this.slGroup && this.slGroup.id) && 
           this.reviewSuggestionListsService.getIsCurrentUserHead();
  }

  showRedirectInputReadonly(): boolean {
    return !this.reviewSuggestionListsService.getIsCurrentUserHead() || 
           this.shouldShowTaskProgress() || 
           !this.canCreateTasks();
  }

  loadPhotos(photoIds: string[]) {
    this.photoUrls = [];
    
    photoIds.forEach(photoId => {
      this.suggestionListsService.getPhotoById(photoId).subscribe(
        (res: any) => {
          if (res.status === HttpStatus.OK && res.body) {
            const photoUrl = URL.createObjectURL(res.body);
            const safeUrl = this.sanitizer.bypassSecurityTrustUrl(photoUrl);
            this.photoUrls.push(safeUrl);
          }
        },
        (error) => {
          console.error('Photo loading failed for id:', photoId, error);
        }
      );
    });
  }

  openPhotoModal(photoUrl: SafeUrl) {
    this.currentPhotoIndex = this.photoUrls.indexOf(photoUrl);
    this.selectedPhotoUrl = photoUrl;
    this.showPhotoModal = true;
  }

  closePhotoModal() {
    this.showPhotoModal = false;
    this.selectedPhotoUrl = '';
  }

  nextPhoto() {
    if (this.currentPhotoIndex < this.photoUrls.length - 1) {
      this.currentPhotoIndex++;
      this.selectedPhotoUrl = this.photoUrls[this.currentPhotoIndex];
    }
  }

  previousPhoto() {
    if (this.currentPhotoIndex > 0) {
      this.currentPhotoIndex--;
      this.selectedPhotoUrl = this.photoUrls[this.currentPhotoIndex];
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if (this.showPhotoModal) {
      this.closePhotoModal();
    }
  }

  @HostListener('document:keydown.arrowleft', ['$event'])
  onArrowLeft(event: KeyboardEvent) {
    if (this.showPhotoModal) {
      this.previousPhoto();
    }
  }

  @HostListener('document:keydown.arrowright', ['$event'])
  onArrowRight(event: KeyboardEvent) {
    if (this.showPhotoModal) {
      this.nextPhoto();
    }
  }

  trackByPhotoIndex(index: number, photoUrl: SafeUrl): number {
    return index;
  }

  trackByHistoryId(index: number, history: any): string {
    return history.id ? history.id.toString() : index.toString();
  }

  trackByGroupId(index: number, group: any): string {
    return group.id ? group.id.toString() : index.toString();
  }

  trackByTaskParticipant(index: number, divisionAndHead: any): string {
    const workerId = divisionAndHead.workerId || divisionAndHead.id || '';
    const groupId = (divisionAndHead.group && divisionAndHead.group.id) || '';
    return `${workerId}-${groupId}` || index.toString();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/view-suggestion-list.component.ts